import { Route } from '@angular/router';
import { qualityGuard } from '../../../core/guards/quality.guard';

export const qualityRoutes: Route[] = [
    {
        path: 'quality',
        canActivate: [qualityGuard],
        children: [
            {
                path: '',
                redirectTo: 'part-requests',
                pathMatch: 'full',
            },
            {
                path: 'part-requests',
                loadComponent: () => import('./part-requests/part-requests').then(m => m.PartRequests),
            }
        ]
    }
];